<template>
  <div class="Orders">
    <h2>Orders</h2>
    <div class="select">
      <div class="select_state">
        <el-select v-model="state" placeholder="Select State" @change="onStateChange">
          <el-option
              v-for="item in states"
              :key="item.state"
              :label="item.label"
              :value="item.state">
          </el-option>
        </el-select>
      </div>
      <div class="select_time">
        <el-date-picker
            @change="onTimeChange"
            type="datetimerange"
            v-model="time_range"
            :picker-options="pickerOptions"
            range-separator="to"
            start-placeholder="Start Time"
            end-placeholder="End Time"
            align="right">
        </el-date-picker>
      </div>
      <div class="select_input">
        <el-input placeholder="Enter Order ID" v-model="order_id" class="input-with-select">
        </el-input>
      </div>
      <div class="select_search">
        <el-button type="primary" size="medium" @click="onOrderSearch">Search</el-button>
      </div>
      <div class="select_reset">
        <el-button size="medium" @click="onOrderReset">Reset</el-button>
      </div>
    </div>
    <OrderList
        @refresh="onOrderSearch"
        :list="order_list">
    </OrderList>

  </div>
</template>

<script>
  import OrderList from "@/components/Orders/OrderList/OrderList";
  import {getOrderList} from "@/utils/api";

  export default {
    components: {
      OrderList
    },
    props: {},
    data: () => {
      return {

        time_range: [],
        states: [
          {
            state: '0',
            label: 'All'
          }, {
            state: '1',
            label: 'Pending Orders'
          }, {
            state: '2',
            label: 'Shipped Orders'
          }, {
            state: '3',
            label: 'Completed Orders'
          }],
        pickerOptions: {
          shortcuts: [{
            text: 'Last 7 days',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: 'Last 1 month',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: 'Last 3 months',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }]
        },
        state: '',
        start_time: 0,
        end_time: 0,
        order_id: '',
        order_list: []
      }
    },

    methods: {
      onStateChange(e) {
        this.state = e
      },
      onTimeChange(e) {
        this.start_time = e ? e[0].getTime() : 0;
        this.end_time = e ? e[1].getTime() : 0;
      },
      onOrderSearch() {
        let state = this.state;
        if (state === '') {
          state = 0
        }
        this.$showLoading('Loading');
        getOrderList(state, this.start_time, this.end_time, this.order_id).then(res => {
          this.order_list = res.order_list;
          this.$hideLoading()
        })
      },
      onOrderReset() {
        this.state = '';
        this.start_time = 0;
        this.end_time = 0;
        this.order_id = '';
        this.$showLoading('Loading');
        getOrderList(0, 0, 0, '').then(res => {
          this.order_list = res.order_list;
          this.$hideLoading()
        })
      },
    },
    beforeMount() {
      this.$showLoading('Loading');
      getOrderList(0, 0, 0, '').then(res => {
        this.order_list = res.order_list;
        this.$hideLoading()
      })
    }
  };

</script>


<style lang="scss" scoped>
  @import "_Orders.scss";
</style>